'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ProductColor } from 'product/types'

interface ColorsAmountLabelProps {
	productColors: ProductColor[]
}

export const ColorsAmountLabel = ({
	productColors,
}: ColorsAmountLabelProps) => {
	const { t } = useLabels()

	const placeholderColorValue = { 1: productColors?.length.toString() }

	return (
		<ClientLabel placeholderValues={placeholderColorValue}>
			{t('plp.home.colors.text.withVariable')}
		</ClientLabel>
	)
}
